import { useState } from 'react'
import api from '../services/api'

// Alterar Código do Funcionário (WCONMOT do ERP) — troca o código em todas as tabelas, numa transação só

export default function FuncionarioAlterarCodigoModal({ motcod, motnome, onClose, onAlterado }: {
  motcod: string; motnome: string; onClose: () => void; onAlterado: (novo: string) => void
}) {
  const [novo, setNovo] = useState('')
  const [erro, setErro] = useState('')
  const [executando, setExecutando] = useState(false)
  const [resultado, setResultado] = useState<{ total: number; porTabela: { tabela: string; linhas: number }[] } | null>(null)

  async function executar() {
    setErro('')
    const n = novo.trim().toUpperCase()
    if (!n) return setErro('Código inválido!')
    if (n === motcod.trim().toUpperCase()) return setErro('O código novo é igual ao atual.')
    if (!window.confirm(`Confirma execução de conversão?\n\n${motcod} → ${n}\n\nO código será trocado em todas as tabelas do sistema (cadastro, salários, abastecimentos, ponto, ocorrências…).`)) return
    setExecutando(true)
    try {
      const r = await api.post(`/funcionarios/${encodeURIComponent(motcod)}/alterar-codigo`, { novo: n })
      setResultado(r.data)
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao alterar o código.')
    } finally {
      setExecutando(false)
    }
  }

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && !executando && onClose()}>
      <div className="modal-box" style={{ maxWidth: 520, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>Alterar Código do Funcionário</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>WCONMOT</span>
            <button className="modal-fechar" onClick={onClose} disabled={executando}>✕</button>
          </div>
        </div>

        <div className="modal-corpo" style={{ overflowY: 'auto' }}>
          {!resultado ? (
            <>
              <p style={{ margin: '0 0 0.9rem', fontSize: '0.85rem', color: '#374151' }}>
                <b>{motnome}</b> — código atual <b>{motcod}</b>
              </p>
              <div className="field" style={{ margin: 0 }}>
                <label>Código novo</label>
                <input value={novo} maxLength={10} autoFocus style={{ width: '14ch' }} disabled={executando}
                  onChange={e => setNovo(e.target.value.toUpperCase())} onKeyDown={e => e.key === 'Enter' && executar()} />
              </div>
              <p style={{ margin: '0.9rem 0 0', fontSize: '0.75rem', color: '#6b7280' }}>
                Troca o código em todas as tabelas do sistema de uma vez: se der erro em qualquer uma, nada é alterado.
                Pode demorar alguns segundos.
              </p>
            </>
          ) : (
            <>
              <p style={{ margin: '0 0 0.6rem', color: '#16a34a', fontWeight: 600, fontSize: '0.9rem' }}>
                Código alterado: {motcod} → {novo.trim().toUpperCase()} ({resultado.total} registro(s)).
              </p>
              <table className="table" style={{ width: '100%' }}>
                <thead><tr><th style={{ padding: '0.4rem 0.6rem', fontSize: '0.72rem' }}>Tabela</th><th style={{ padding: '0.4rem 0.6rem', fontSize: '0.72rem', textAlign: 'right' }}>Registros</th></tr></thead>
                <tbody>
                  {resultado.porTabela.map(t => (
                    <tr key={t.tabela}><td style={{ padding: '0.3rem 0.6rem', fontSize: '0.82rem', fontFamily: 'monospace' }}>{t.tabela}</td>
                      <td style={{ padding: '0.3rem 0.6rem', fontSize: '0.82rem', textAlign: 'right' }}>{t.linhas}</td></tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '0.9rem 0 0' }}>{erro}</p>}
        </div>

        <div className="modal-footer">
          {!resultado ? (
            <>
              <button className="btn btn-secondary" onClick={onClose} disabled={executando}>Cancelar</button>
              <button className="btn btn-orange" onClick={executar} disabled={executando}>{executando ? 'Alterando...' : 'Alterar código'}</button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={() => onAlterado(novo.trim().toUpperCase())}>Fechar</button>
          )}
        </div>
      </div>
    </div>
  )
}
